import { SnackbarProvider } from 'notistack';
import { BrowserRouter } from 'react-router-dom';

import 'helpers/Extensions';

import { LicenseInfo } from '@mui/x-license-pro';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { enUS } from '@mui/x-date-pickers';

import theme from 'assets';

import { Routes, AxiosInterceptors } from 'components';
import { AuthProvider } from 'helpers/services';
import { CssBaseline, ThemeProvider } from '@mui/material';

LicenseInfo.setLicenseKey('b6ebaee9a3fd555a2891ada02f03e379Tz00MzcxMCxFPTE2ODQwNzc4MDEwMDAsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI=');

function App() {
  return (
    <ThemeProvider theme={theme}>
      <LocalizationProvider dateAdapter={AdapterMoment} localeText={enUS.components.MuiLocalizationProvider.defaultProps.localeText}>
        <CssBaseline />
        <SnackbarProvider preventDuplicate autoHideDuration={4000}>
          <BrowserRouter>
            <AuthProvider>
              <AxiosInterceptors />
              <Routes />
            </AuthProvider>
          </BrowserRouter>
        </SnackbarProvider>
      </LocalizationProvider>
    </ThemeProvider>
  );
}

export default App;
